import { PageContainer } from '@components/PageContainer';
import { MessagesIcon } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';

export const MessagesLayout = () => {
	const { t } = useTranslation('', { keyPrefix: 'messages' });
	const location = useLocation();

	const isNewMessage = location.pathname.endsWith('/new');
	const isMessagesRoot = location.pathname === '/messages';
	const isMessageDetails =
		!isMessagesRoot && !isNewMessage && /^\/messages\/[^/]+$/.test(location.pathname);

	const title = isNewMessage ? t('newMessage.button') : t('title');

	return (
		<PageContainer
			backUrl={isMessagesRoot ? undefined : '/messages'}
			icon={
				isMessageDetails || isNewMessage ? undefined : (
					<MessagesIcon className="text-brand-primary-600 stroke-[1.5px]" />
				)
			}
			title={title}
		>
			<Outlet />
		</PageContainer>
	);
};
